module.exports = __webpack_public_path__ + "img/answer-c4-2.a8a83a53.png";